/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
/** Known values of {@link Workload} that the service accepts. */
export var KnownWorkload;
(function (KnownWorkload) {
    KnownWorkload["Production"] = "Production";
    KnownWorkload["DevTest"] = "DevTest";
})(KnownWorkload || (KnownWorkload = {}));
/** Known values of {@link ProvisioningState} that the service accepts. */
export var KnownProvisioningState;
(function (KnownProvisioningState) {
    KnownProvisioningState["Accepted"] = "Accepted";
    KnownProvisioningState["Succeeded"] = "Succeeded";
    KnownProvisioningState["Failed"] = "Failed";
})(KnownProvisioningState || (KnownProvisioningState = {}));
/** Known values of {@link AcceptOwnership} that the service accepts. */
export var KnownAcceptOwnership;
(function (KnownAcceptOwnership) {
    KnownAcceptOwnership["Pending"] = "Pending";
    KnownAcceptOwnership["Completed"] = "Completed";
    KnownAcceptOwnership["Expired"] = "Expired";
})(KnownAcceptOwnership || (KnownAcceptOwnership = {}));
/** Known values of {@link CreatedByType} that the service accepts. */
export var KnownCreatedByType;
(function (KnownCreatedByType) {
    KnownCreatedByType["User"] = "User";
    KnownCreatedByType["Application"] = "Application";
    KnownCreatedByType["ManagedIdentity"] = "ManagedIdentity";
    KnownCreatedByType["Key"] = "Key";
})(KnownCreatedByType || (KnownCreatedByType = {}));
//# sourceMappingURL=index.js.map